import React from 'react'
import FooterWidgetComponent from '../../widgets/FooterWidget/FooterWidgetComponent'
import PrivacyBannerComponent from './widget/PrivacyBanner/PrivacyBannerComponent'
import SectionAComponent from './widget/SectionA/SectionAComponent'

function Privacy() {
  return (
    <div>
        <PrivacyBannerComponent/>
        <SectionAComponent/>
        <FooterWidgetComponent/>
    </div>
  )
}

export default Privacy